(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnounceBar extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[role="region"]');
      this.marquee = this.querySelector('[data-marquee]');
      this.group = this.querySelector('[data-group]');
      if (!this.track || !this.marquee || !this.group) return;

      this.fill();

      // A largura muda quando a fonte carrega e quando a janela muda.
      this.observer = new ResizeObserver(() => this.fill());
      this.observer.observe(this.track);
      document.fonts?.ready.then(() => this.fill());

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-announce-toggle]')) this.toggle();
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    fill() {
      this.marquee.querySelectorAll('[data-clone]').forEach((node) => node.remove());

      const groupWidth = this.group.getBoundingClientRect().width;
      const trackWidth = this.track.getBoundingClientRect().width;
      if (!groupWidth || !trackWidth) return;

      // Uma cópia a mais do que cabe na tela: quando a primeira sai por
      // completo, o que está na tela é idêntico ao quadro inicial.
      const copies = Math.max(2, Math.ceil(trackWidth / groupWidth) + 1);
      const fragment = document.createDocumentFragment();
      for (let i = 1; i < copies; i++) {
        const clone = this.group.cloneNode(true);
        clone.removeAttribute('data-group');
        clone.setAttribute('data-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        fragment.appendChild(clone);
      }
      this.marquee.appendChild(fragment);

      // Velocidade constante em px/s, não importa quantos avisos existam.
      const pxPerSecond = Number(this.dataset.speed) || 60;
      this.style.setProperty('--announce-distance', `-${groupWidth}px`);
      this.style.setProperty('--announce-duration', `${groupWidth / pxPerSecond}s`);
    }

    toggle() {
      const button = this.querySelector('[data-announce-toggle]');
      const paused = this.dataset.paused !== 'true';

      this.dataset.paused = String(paused);
      button.setAttribute('aria-pressed', String(paused));
      button.setAttribute('aria-label', paused ? button.dataset.labelPlay : button.dataset.labelPause);
      this.querySelector('[data-when="running"]').hidden = paused;
      this.querySelector('[data-when="paused"]').hidden = !paused;
    }
  }

  if (!customElements.get('announce-bar')) {
    customElements.define('announce-bar', AnnounceBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      this.root = this.dataset.root || '/';
      // routes.root_url vem SEM barra nos idiomas ("/ja"): sem isto o carrinho chamava "/jacart/add.js" e o botão não fazia nada
      if (!this.root.endsWith('/')) this.root += '/';
      this.sectionId = this.dataset.section;
      this.bind();

      // Qualquer botão com data-open="bag" abre; o link segue funcionando sem JS.
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-open="bag"]');
        if (trigger) {
          event.preventDefault();
          return this.open();
        }
      });

      // Formulário de produto: adiciona por AJAX e abre a gaveta em vez de
      // navegar pra /cart. Aceita a notação items[N][...] do form nativo.
      document.addEventListener('submit', (event) => {
        const form = event.target.closest('form.pdp__form');
        if (!form) return;
        event.preventDefault();
        this.addFromForm(form, event.submitter?.dataset.buyNow || false);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.dialog?.open) this.close();
      });

      this.initTimer();
      this.syncPromoDrop();
    }

    // Os nós trocam a cada re-render, então os handlers vivem no host.
    bind() {
      this.dialog = this.querySelector('[data-cart-panel]');
      this.sheet = this.querySelector('[data-sheet]');

      if (this.boundDialog) return;
      this.boundDialog = true;

      this.addEventListener('click', (event) => {
        if (event.target === this.dialog) return this.close();
        if (event.target.closest('[data-close]')) return this.close();

        const change = event.target.closest('[data-change]');
        if (change) {
          event.preventDefault();
          this.change(change.dataset.change, Number(change.dataset.qty));
        }
      });

      this.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      });

      // RFC (México): grava como atributo do carrinho e barra o checkout se inválido.
      this.addEventListener('input', (event) => {
        const input = event.target.closest('[data-rfc]');
        if (!input) return;
        input.value = input.value.toUpperCase().replace(/[^A-Z0-9&Ñ]/g, '');
        this.querySelector('[data-rfc-error]')?.setAttribute('hidden', '');
        clearTimeout(this.rfcTimer);
        this.rfcTimer = setTimeout(() => this.saveRfc(input.value), 400);
      });

      // Cupom: aplica pela API e re-renderiza; Enter no campo também aplica.
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-promo-apply]')) return this.applyPromo();
        if (event.target.closest('[data-promo-remove]')) return this.setDiscount('');
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && event.target.closest('[data-promo-input]')) {
          event.preventDefault();
          this.applyPromo();
        }
      });

      this.addEventListener('submit', (event) => {
        const form = event.target.closest('[data-checkout]');
        if (!form) return;
        const input = this.querySelector('[data-rfc]');
        if (input && !this.rfcValid(input.value)) {
          event.preventDefault();
          this.querySelector('[data-rfc-error]')?.removeAttribute('hidden');
          input.focus();
        }
      });
    }

    rfcValid(value) {
      const v = (value || '').trim();
      return v.length === 12 || v.length === 13 || v.length === 18;
    }

    async saveRfc(value) {
      try {
        await fetch(`${this.root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { RFC: value } }),
        });
      } catch {
        /* sem rede: o campo continua preenchido, tenta de novo no próximo input */
      }
    }

    // Cupom: no desktop sempre aberto; no celular vira o link "Have a promo code?".
    syncPromoDrop() {
      const drop = this.querySelector('[data-promo-drop]');
      if (drop && window.matchMedia('(min-width: 750px)').matches) drop.open = true;
    }

    async applyPromo() {
      const input = this.querySelector('[data-promo-input]');
      const code = (input?.value || '').trim().toUpperCase();
      if (!code) return input?.focus();
      const button = this.querySelector('[data-promo-apply]');
      if (button) button.disabled = true;
      const ok = await this.setDiscount(code);
      if (ok === false) {
        // A seção não foi trocada: mostra o erro no lugar, com o código ainda no campo.
        this.querySelector('[data-promo-error]')?.removeAttribute('hidden');
        if (button) button.disabled = false;
        input?.focus();
      }
    }

    // Devolve true se aplicou (e já re-renderizou), false se o código não vale.
    async setDiscount(code) {
      this.busy(true);
      try {
        const res = await fetch(`${this.root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: code }),
        });
        const cart = await res.json();
        if (code) {
          const hit = (cart.discount_codes || []).find((d) => d.code.toUpperCase() === code);
          if (!hit || !hit.applicable) {
            // Limpa o código rejeitado do carrinho pra não viajar pro checkout.
            await fetch(`${this.root}cart/update.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ discount: '' }),
            });
            this.busy(false);
            return false;
          }
        }
      } catch {
        this.busy(false);
        return false;
      }
      await this.refresh();
      return true;
    }

    // ---------- abrir / fechar ----------
    open() {
      this.dialog = this.querySelector('[data-cart-panel]');
      if (!this.dialog || this.dialog.open) return;
      this.dialog.showModal();
      requestAnimationFrame(() => {
        this.dialog.dataset.state = 'open';
      });
    }

    close() {
      if (!this.dialog?.open) return;
      delete this.dialog.dataset.state;

      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        this.dialog.close();
      };
      this.sheet?.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, 700);
    }

    // ---------- dados ----------
    busy(on) {
      this.sheet?.setAttribute('aria-busy', on ? 'true' : 'false');
    }

    // Busca a seção renderizada de novo e troca a folha inteira: preço,
    // moeda, escada e descontos saem do Liquid, nunca do JS.
    // Pela raiz e sem Accept: json — em /products/<handle> o Accept json faz a
    // Shopify devolver o JSON do produto em vez da seção.
    async refresh() {
      const wasOpen = this.dialog?.open;
      try {
        const res = await fetch(`${this.root}?sections=${this.sectionId}`);
        const data = await res.json();
        const html = data[this.sectionId];
        if (!html) return;

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('cart-drawer');
        if (!fresh) return;

        const freshSheet = fresh.querySelector('[data-sheet]');
        this.sheet.innerHTML = freshSheet.innerHTML;
        this.dataset.count = fresh.dataset.count;
        this.syncCount(Number(fresh.dataset.count) || 0);
        this.initTimer();
        this.syncPromoDrop();
        // Coracoes recem-renderizados precisam do estado salvo.
        document.querySelector('saved-store')?.refresh?.();
        if (wasOpen) this.dialog.dataset.state = 'open';
      } finally {
        this.busy(false);
      }
    }

    syncCount(count) {
      document.querySelectorAll('[data-bag-count]').forEach((badge) => {
        badge.textContent = count;
        badge.hidden = count === 0;
      });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count } }));
    }

    async change(line, quantity) {
      this.busy(true);
      try {
        await fetch(`${this.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line, quantity: Math.max(0, quantity) }),
        });
      } catch {
        /* cai no refresh mesmo assim: o estado real vem do servidor */
      }
      await this.refresh();
    }

    // items[0][id]=..., items[0][properties][Name]=..., items[1][id]=... -> {items:[...]}
    itemsFrom(form) {
      const items = [];
      for (const [key, value] of new FormData(form).entries()) {
        const match = key.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
        const prop = key.match(/^items\[(\d+)\]\[properties\]\[(.+)\]$/);
        if (match) {
          const i = Number(match[1]);
          items[i] = items[i] || { quantity: 1 };
          items[i][match[2]] = Number(value);
        } else if (prop) {
          const i = Number(prop[1]);
          items[i] = items[i] || { quantity: 1 };
          items[i].properties = items[i].properties || {};
          items[i].properties[prop[2]] = value;
        } else if (key === 'id') {
          items[0] = items[0] || { quantity: 1 };
          items[0].id = Number(value);
        } else if (key === 'quantity') {
          items[0] = items[0] || { quantity: 1 };
          items[0].quantity = Number(value);
        }
      }
      return items.filter((item) => item && item.id);
    }

    async addFromForm(form, buyNow = false) {
      const items = this.itemsFrom(form);
      if (!items.length) return form.submit();

      const button = buyNow ? form.querySelector(`[data-buy-now="${buyNow}"]`) : form.querySelector('[type="submit"]:not([disabled])') || document.querySelector('[data-sticky-add]');
      const label = button?.querySelector('span');
      const idle = label?.textContent;
      if (button) button.disabled = true;

      try {
        const res = await fetch(`${this.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          if (label && err.description) {
            label.textContent = err.description;
            setTimeout(() => { label.textContent = idle; }, 2600);
          }
          return;
        }
        if (buyNow) {
          window.location.href = buyNow === 'shop_pay' ? `${this.root}checkout?payment=shop_pay` : `${this.root}checkout`;
          return;
        }
        await this.refresh();
        this.querySelector('.cart__row')?.classList.add('is-new');
        this.open();
      } catch {
        form.submit();
      } finally {
        if (button) button.disabled = false;
      }
    }

    // ---------- timer de urgência ----------
    initTimer() {
      const el = this.querySelector('[data-cart-timer]');
      clearInterval(this.timerInt);
      if (!el) return;

      const minutes = Number(this.dataset.timerMin) || 5;
      const span = minutes * 60000;
      const key = 'flp:cart-timer-end';
      let end = 0;
      try { end = Number(localStorage.getItem(key)) || 0; } catch { /* sem storage */ }
      if (!end || end < Date.now()) {
        end = Date.now() + span;
        try { localStorage.setItem(key, String(end)); } catch { /* sem storage */ }
      }

      const tick = () => {
        let left = end - Date.now();
        if (left <= 0) {
          end = Date.now() + span;
          try { localStorage.setItem(key, String(end)); } catch { /* sem storage */ }
          left = span;
        }
        const m = Math.floor(left / 60000);
        const s = Math.floor((left % 60000) / 1000);
        el.textContent = `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
      };
      tick();
      this.timerInt = setInterval(tick, 1000);
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

  // Arraste pra desbloquear. Pointer events cobrem dedo e mouse; teclado
  // (Enter, espaço ou seta) destrava direto.
  class GiftSlider extends HTMLElement {
    connectedCallback() {
      this.key = this.dataset.key || 'flp:gift-unlocked';
      this.track = this.querySelector('[data-track]');
      this.knob = this.querySelector('[data-knob]');
      this.done = this.querySelector('[data-done]');
      if (!this.track || !this.knob) return;

      let unlocked = false;
      try { unlocked = localStorage.getItem(this.key) === '1'; } catch { /* sem storage */ }
      if (unlocked) return this.unlock(true);

      this.knob.addEventListener('pointerdown', (event) => this.start(event));
      this.knob.addEventListener('keydown', (event) => {
        if (['Enter', ' ', 'ArrowRight', 'End'].includes(event.key)) {
          event.preventDefault();
          this.settle(this.max());
        }
      });
    }

    max() {
      return this.track.clientWidth - this.knob.offsetWidth - 10;
    }

    set(x) {
      const max = this.max() || 1;
      const clamped = Math.max(0, Math.min(max, x));
      this.style.setProperty('--x', clamped + 'px');
      this.style.setProperty('--progress', (clamped / max).toFixed(3));
      // Enche devagar no começo e forte no fim: o rótulo some antes de a lima cobrir tudo.
      const p = clamped / max;
      this.style.setProperty('--fill-opacity', (0.1 + p * p * 0.3).toFixed(3));
      return clamped;
    }

    start(event) {
      event.preventDefault();
      this.removeAttribute('data-settling');
      this.knob.setPointerCapture(event.pointerId);
      const origin = event.clientX - (parseFloat(getComputedStyle(this).getPropertyValue('--x')) || 0);
      const move = (e) => { this.current = this.set(e.clientX - origin); };
      const end = () => {
        this.knob.removeEventListener('pointermove', move);
        this.knob.removeEventListener('pointerup', end);
        this.knob.removeEventListener('pointercancel', end);
        this.settle(this.current || 0);
      };
      this.knob.addEventListener('pointermove', move);
      this.knob.addEventListener('pointerup', end);
      this.knob.addEventListener('pointercancel', end);
    }

    // Passou de 80% do caminho: completa e destrava. Senão, volta ao início.
    settle(x) {
      const max = this.max();
      this.setAttribute('data-settling', '');
      if (x >= max * 0.8) {
        this.set(max);
        setTimeout(() => this.unlock(false), 420);
      } else {
        this.set(0);
      }
    }

    unlock(silent) {
      try { localStorage.setItem(this.key, '1'); } catch { /* sem storage */ }
      this.dataset.state = 'unlocked';
      if (this.done) {
        this.done.hidden = false;
        if (silent) this.done.style.animation = 'none';
      }
    }
  }

  if (!customElements.get('gift-slider')) {
    customElements.define('gift-slider', GiftSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  // O seletor de país e idioma envia sozinho ao mudar — sem botão "aplicar".
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-localization]');
    if (select) select.form?.submit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class ShopPanel extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-panel]');
      if (!this.dialog) return;

      this.sheets = this.querySelector('[data-sheets]');
      this.branches = Array.from(this.querySelectorAll('[data-branch-panel]'));
      this.items = Array.from(this.querySelectorAll('[data-branch]'));
      this.desktop = window.matchMedia('(min-width: 1024px)');

      // Qualquer botao da pagina com data-open="menu" abre este painel.
      document.addEventListener('click', (event) => {
        if (event.target.closest('[data-open="menu"]')) this.open();
      });

      this.dialog.addEventListener('click', (event) => {
        // Clique fora das folhas fecha: ai o alvo e o proprio dialog.
        if (event.target === this.dialog) return this.close();
        if (event.target.closest('[data-close]')) return this.close();
        if (event.target.closest('[data-back]')) return this.closeSub();

        const item = event.target.closest('[data-branch]');
        if (item) this.showBranch(item);
      });

      // Esc: deixa a animacao correr antes de sumir.
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      });

      this.dialog.addEventListener('mouseover', (event) => {
        if (!this.desktop.matches) return;
        const item = event.target.closest('[data-branch]');
        if (item) this.showBranch(item);
      });
    }

    open() {
      if (this.dialog.open) return;
      this.dialog.showModal();
      // No desktop ja entra com o primeiro item aberto: a folha da direita
      // nunca aparece vazia.
      if (this.desktop.matches && this.items[0]) this.showBranch(this.items[0]);
      requestAnimationFrame(() => {
        this.dialog.dataset.state = 'open';
      });
    }

    close() {
      if (!this.dialog.open) return;
      delete this.dialog.dataset.state;
      this.dialog.dataset.subOpen = 'false';

      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        this.dialog.close();
      };
      this.sheets.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, 700);
    }

    showBranch(item) {
      const id = item.dataset.branch;
      this.items.forEach((btn) => btn.setAttribute('aria-expanded', String(btn === item)));
      this.branches.forEach((panel) => {
        panel.hidden = panel.dataset.branchPanel !== id;
      });
      if (!this.desktop.matches) this.dialog.dataset.subOpen = 'true';
    }

    closeSub() {
      this.dialog.dataset.subOpen = 'false';
      this.items.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
    }
  }

  class SavedStore extends HTMLElement {
    connectedCallback() {
      this.key = 'flp:saved';
      this.dialog = this.querySelector('[data-saved-panel]');
      this.sheet = this.querySelector('[data-sheet]');
      this.list = this.querySelector('[data-saved-list]');
      this.empty = this.querySelector('[data-saved-empty]');
      this.promo = this.querySelector('[data-saved-promo]');

      document.addEventListener('click', (event) => {
        if (event.target.closest('[data-open="saved"]')) return this.open();

        const save = event.target.closest('[data-save]');
        if (save) {
          // Se um dia o botao morar dentro de um link, o clique nao navega.
          event.preventDefault();
          return this.toggle(save);
        }

        const remove = event.target.closest('[data-remove]');
        if (remove) return this.remove(remove.dataset.remove);

        const copy = event.target.closest('[data-copy-code]');
        if (copy) return this.copy(copy);
      });

      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) return this.close();
        if (event.target.closest('[data-close]')) return this.close();
      });

      this.dialog?.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      });

      // Outra aba mexeu na lista: acompanha sem recarregar.
      window.addEventListener('storage', (event) => {
        if (event.key === this.key) this.refresh();
      });

      this.refresh();
    }

    read() {
      try {
        const raw = JSON.parse(localStorage.getItem(this.key) || '[]');
        return Array.isArray(raw) ? raw : [];
      } catch {
        return [];
      }
    }

    write(items) {
      try {
        localStorage.setItem(this.key, JSON.stringify(items));
      } catch {
        /* navegacao privada: a lista vale so nesta visita */
      }
      this.refresh();
    }

    toggle(button) {
      const handle = button.dataset.handle;
      const items = this.read();
      const found = items.some((item) => item.handle === handle);

      if (found) {
        this.write(items.filter((item) => item.handle !== handle));
        return;
      }

      // Guarda o que a gaveta precisa mostrar. O preco e o do momento em que
      // foi salvo: o valor que vale e sempre o da pagina do produto.
      this.write([
        {
          handle,
          title: button.dataset.title,
          url: button.dataset.url,
          image: button.dataset.image,
          price: button.dataset.price,
        },
        ...items,
      ]);
    }

    remove(handle) {
      this.write(this.read().filter((item) => item.handle !== handle));
    }

    refresh() {
      const items = this.read();
      const handles = new Set(items.map((item) => item.handle));

      document.querySelectorAll('[data-save]').forEach((button) => {
        button.setAttribute('aria-pressed', String(handles.has(button.dataset.handle)));
      });

      document.querySelectorAll('[data-saved-count]').forEach((badge) => {
        badge.textContent = items.length;
        badge.hidden = items.length === 0;
      });

      document.querySelectorAll('[data-saved-count-inline]').forEach((el) => {
        el.textContent = items.length ? '(' + items.length + ')' : '';
      });

      if (!this.list) return;
      this.list.innerHTML = items.map((item) => this.row(item)).join('');
      if (this.empty) this.empty.hidden = items.length > 0;
      if (this.promo) this.promo.hidden = items.length === 0;
    }

    row(item) {
      const esc = (value) =>
        String(value || '').replace(/[&<>"']/g, (ch) => ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;',
        })[ch]);

      const image = item.image
        ? '<span class="sv__row-media"><img src="' + esc(item.image) + '" alt="" width="56" height="70" loading="lazy"></span>'
        : '<span class="sv__row-media"></span>';

      return (
        '<li class="sv__row">' +
        image +
        '<a class="sv__row-copy" href="' + esc(item.url) + '">' +
        '<span class="sv__row-title">' + esc(item.title) + '</span>' +
        '<span class="sv__row-price">' + esc(item.price) + '</span>' +
        '</a>' +
        '<button type="button" class="sv__row-x" data-remove="' + esc(item.handle) + '" aria-label="Remove">' +
        '<svg class="flp-icon" style="--flp-icon-size:14px" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>' +
        '</button>' +
        '</li>'
      );
    }

    async copy(button) {
      const hint = button.querySelector('[data-hint]');
      try {
        await navigator.clipboard.writeText(button.dataset.copyCode || '');
        if (!hint) return;
        hint.textContent = button.dataset.done;
        clearTimeout(this.copyTimer);
        this.copyTimer = setTimeout(() => {
          hint.textContent = button.dataset.idle;
        }, 2200);
      } catch {
        /* sem permissao de area de transferencia: o codigo esta a vista mesmo */
      }
    }

    open() {
      if (!this.dialog || this.dialog.open) return;
      this.dialog.showModal();
      requestAnimationFrame(() => {
        this.dialog.dataset.state = 'open';
      });
    }

    close() {
      if (!this.dialog?.open) return;
      delete this.dialog.dataset.state;

      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        this.dialog.close();
      };
      this.sheet.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, 700);
    }
  }

  if (!customElements.get('saved-store')) {
    customElements.define('saved-store', SavedStore);
  }

  if (!customElements.get('shop-panel')) {
    customElements.define('shop-panel', ShopPanel);
  }

  class SearchPanel extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-search-panel]');
      if (!this.dialog) return;

      this.sheet = this.querySelector('[data-sheet]');
      this.input = this.querySelector('[data-search-input]');
      this.results = this.querySelector('[data-results]');
      this.idle = this.querySelector('[data-idle]');

      document.addEventListener('click', (event) => {
        if (event.target.closest('[data-open="search"]')) this.open();
      });

      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) return this.close();
        if (event.target.closest('[data-close]')) return this.close();
      });

      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      });

      this.input.addEventListener('input', () => {
        clearTimeout(this.timer);
        // Espera a pessoa parar de digitar: sem isso e uma requisicao por tecla.
        this.timer = setTimeout(() => this.search(), 260);
      });
    }

    open() {
      if (this.dialog.open) return;
      this.dialog.showModal();
      requestAnimationFrame(() => {
        this.dialog.dataset.state = 'open';
        this.input.focus();
      });
    }

    close() {
      if (!this.dialog.open) return;
      delete this.dialog.dataset.state;

      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        this.dialog.close();
      };
      this.sheet.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, 700);
    }

    async search() {
      const q = this.input.value.trim();

      if (q.length < 2) {
        this.results.innerHTML = '';
        if (this.idle) this.idle.hidden = false;
        return;
      }

      this.controller?.abort();
      this.controller = new AbortController();

      const url =
        routesSearchUrl +
        '/suggest?q=' +
        encodeURIComponent(q) +
        '&resources[type]=product,collection,query&resources[limit]=6' +
        '&section_id=predictive-search';

      try {
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) return;
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const out = doc.querySelector('.srch__out');
        if (!out) return;
        this.results.innerHTML = out.outerHTML;
        if (this.idle) this.idle.hidden = true;
      } catch {
        /* requisicao trocada por uma mais nova, ou rede caiu */
      }
    }
  }

  if (!customElements.get('search-panel')) {
    customElements.define('search-panel', SearchPanel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["league-collections"] && !Shopify.designMode) return;
  try {
    
  class LeagueCollections extends HTMLElement {
    connectedCallback() {
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.tabs = this.buildTabs();
      this.arrows = Array.from(this.querySelectorAll('[data-scroll]'));
      if (!this.tabs.length) return;

      this.tabsWrap = this.querySelector('[data-tabs-wrap]');
      this.tabsList = this.querySelector('[data-tabs]');
      this.tabsList.addEventListener('scroll', () => this.syncHint(), { passive: true });
      new ResizeObserver(() => this.syncHint()).observe(this.tabsList);
      this.syncHint();

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', (event) => this.onKey(event, index));
      });

      this.arrows.forEach((arrow) => {
        arrow.addEventListener('click', () => this.step(arrow.dataset.scroll));
      });

      this.querySelectorAll('[data-track]').forEach((track) => {
        track.addEventListener('scroll', () => this.syncArrows(), { passive: true });
      });

      this.syncArrows();
    }

    buildTabs() {
      const list = this.querySelector('[data-tabs]');
      if (!list) return [];

      return this.panels.map((panel, index) => {
        const tab = document.createElement('button');
        tab.type = 'button';
        tab.className = 'lg__tab';
        tab.setAttribute('role', 'tab');
        tab.id = `tab-${panel.id}`;
        tab.setAttribute('aria-controls', panel.id);
        tab.setAttribute('aria-selected', String(index === 0));
        tab.tabIndex = index === 0 ? 0 : -1;
        tab.textContent = panel.dataset.title || String(index + 1);
        panel.setAttribute('aria-labelledby', tab.id);
        panel.hidden = index !== 0;
        list.appendChild(tab);
        return tab;
      });
    }

    syncHint() {
      if (!this.tabsWrap || !this.tabsList) return;
      const list = this.tabsList;
      const overflow = list.scrollWidth - list.clientWidth;
      const atEnd = list.scrollLeft >= overflow - 1;
      this.tabsWrap.dataset.scrolled = overflow <= 1 ? 'none' : atEnd ? 'end' : 'more';
    }

    get activeTrack() {
      return this.panels.find((panel) => panel && !panel.hidden)?.querySelector('[data-track]');
    }

    select(index) {
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (this.panels[i]) this.panels[i].hidden = !active;
      });
      this.tabs[index].focus();
      this.syncArrows();
    }

    onKey(event, index) {
      const step = { ArrowRight: 1, ArrowLeft: -1 }[event.key];
      if (!step) return;
      event.preventDefault();
      this.select((index + step + this.tabs.length) % this.tabs.length);
    }

    step(direction) {
      const track = this.activeTrack;
      const card = track?.querySelector('.flp-ccard');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const distance = card.getBoundingClientRect().width + gap;
      track.scrollBy({ left: direction === 'next' ? distance : -distance, behavior: 'smooth' });
    }

    syncArrows() {
      const track = this.activeTrack;
      if (!track) return;
      const max = track.scrollWidth - track.clientWidth - 1;
      this.arrows.forEach((arrow) => {
        arrow.disabled =
          arrow.dataset.scroll === 'next' ? track.scrollLeft >= max : track.scrollLeft <= 0;
      });
    }
  }

  if (!customElements.get('league-collections')) {
    customElements.define('league-collections', LeagueCollections);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  // Apagar endereco e irreversivel: confirma antes de enviar o formulario.
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-confirm]');
    if (!button) return;
    if (!window.confirm(button.dataset.confirmText || 'Delete this address?')) {
      event.preventDefault();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  class ProductPage extends HTMLElement {
    connectedCallback() {
      const raw = this.querySelector('[data-variants]');
      if (!raw) return;

      try {
        this.variants = JSON.parse(raw.textContent);
      } catch {
        return;
      }

      this.form = this.querySelector('.pdp__form');
      this.idField = this.querySelector('[data-variant-id]');
      this.buyNowBtns = this.querySelectorAll('[data-buy-now]');
      this.addBtn = this.querySelector('[data-add]');
      this.addLabel = this.querySelector('[data-add-label]');
      this.priceNow = this.querySelector('[data-price-now]');
      this.priceWas = this.querySelector('[data-price-was]');
      this.priceBundle = this.querySelector('[data-price-bundle]');
      this.stickyPrice = this.querySelector('[data-sticky-price]');
      this.stickyAdd = this.querySelector('[data-sticky-add]');
      this.initGalleryDots();
      this.initGalleryMore();
      this.stickyLabel = this.querySelector('[data-sticky-label]');
      this.sticky = this.querySelector('[data-sticky]');
      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';

      this.addEventListener('change', (event) => {
        if (event.target.closest('[data-option-input]')) this.select();
        if (event.target.closest('[data-perso-choice]')) this.syncPerso();
      });

      this.markUnavailable();
      this.watchSticky();
      this.initPerso();
      this.initPatches();
    }

    get chosen() {
      return Array.from(this.querySelectorAll('[data-option-input]:checked')).map((i) => i.value);
    }

    find(values) {
      return this.variants.find((variant) =>
        values.every((value, index) => variant.options[index] === value)
      );
    }

    // Grade do desktop: revela mais 4 fotos por clique; some quando acabam.
    initGalleryMore() {
      const wrap = this.querySelector('[data-gallery-more]');
      const button = wrap?.querySelector('button');
      if (!wrap || !button) return;
      button.addEventListener('click', () => {
        const hidden = Array.from(this.querySelectorAll('.pdp__shot--more'));
        hidden.slice(0, 4).forEach((shot) => shot.classList.remove('pdp__shot--more'));
        if (hidden.length <= 4) wrap.classList.add('is-done');
      });
    }

    // Bolinhas da galeria (celular): a ativa segue a foto que está na tela;
    // tocar numa bolinha rola até a foto dela.
    initGalleryDots() {
      const gallery = this.querySelector('[data-gallery]');
      const dots = Array.from(this.querySelectorAll('[data-gallery-dot]'));
      if (!gallery || dots.length < 2) return;
      const shots = Array.from(gallery.children);
      const setActive = (i) => {
        dots.forEach((d, k) => {
          d.classList.toggle('is-active', k === i);
          d.setAttribute('aria-selected', String(k === i));
        });
      };
      let raf = 0;
      gallery.addEventListener('scroll', () => {
        if (raf) return;
        raf = requestAnimationFrame(() => {
          raf = 0;
          const step = shots[1] ? shots[1].offsetLeft - shots[0].offsetLeft : gallery.clientWidth;
          setActive(Math.max(0, Math.min(shots.length - 1, Math.round(gallery.scrollLeft / Math.max(1, step)))));
        });
      }, { passive: true });
      dots.forEach((d, i) => d.addEventListener('click', () => {
        shots[i]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }));
    }

    select() {
      const values = this.chosen;
      const variant = this.find(values);

      this.querySelectorAll('[data-option-label]').forEach((el, index) => {
        el.textContent = values[index] ?? '';
      });

      if (!variant) {
        this.addBtn.disabled = true;
        this.addLabel.textContent = this.addBtn.dataset.labelUnavailable;
        if (this.stickyAdd) this.stickyAdd.disabled = true;
        if (this.stickyLabel) this.stickyLabel.textContent = this.addBtn.dataset.labelUnavailable;
        return;
      }

      this.idField.value = variant.id;
      this.buyNowBtns?.forEach((b) => { b.disabled = !variant.available; });
      this.addBtn.disabled = !variant.available;
      this.addLabel.textContent = variant.available
        ? this.addBtn.dataset.labelAdd
        : this.addBtn.dataset.labelSoldout;

      if (this.priceNow) this.priceNow.textContent = this.money(variant.price);
      if (this.stickyPrice) this.stickyPrice.textContent = this.money(variant.price);
      if (this.stickyAdd) this.stickyAdd.disabled = !variant.available;
      if (this.stickyLabel) this.stickyLabel.textContent = variant.available ? this.addBtn.dataset.labelAdd : this.addBtn.dataset.labelSoldout;

      if (this.priceBundle) {
        this.priceBundle.innerHTML = this.priceBundle.dataset.template.replace('__P__', this.money(Math.round((variant.price * 2) / 3)));
      }

      if (this.priceWas) {
        const sale = variant.compare_at_price && variant.compare_at_price > variant.price;
        this.priceWas.hidden = !sale;
        if (sale) this.priceWas.textContent = this.money(variant.compare_at_price);
        this.priceNow.classList.toggle('is-sale', Boolean(sale));
      }

      // A URL acompanha a variante: link copiado abre na mesma escolha.
      const url = new URL(this.dataset.url, location.origin);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);

      this.markUnavailable();
    }

    /* Risca o que não existe em combinação com o que já está escolhido. */
    markUnavailable() {
      const values = this.chosen;
      this.querySelectorAll('[data-option-index]').forEach((group) => {
        const index = Number(group.dataset.optionIndex);
        group.querySelectorAll('[data-option-input]').forEach((input) => {
          const test = [...values];
          test[index] = input.value;
          const variant = this.find(test);
          input.disabled = !variant || !variant.available;
        });
      });
    }

    // Formata com o padrão da loja (vem por atributo). Cobre os quatro
    // marcadores da Shopify: amount, amount_no_decimals e as variantes com
    // vírgula como separador decimal.
    money(cents) {
      const value = cents / 100;
      return this.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, token) => {
        const decimals = token.includes('no_decimals') ? 0 : 2;
        const comma = token.includes('with_comma_separator');
        const out = value.toFixed(decimals);
        if (!comma) return out.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return out.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      });
    }

    watchSticky() {
      if (!this.sticky || !this.addBtn) return;
      const observer = new IntersectionObserver(
        ([entry]) => {
          this.sticky.hidden = entry.isIntersecting;
        },
        { rootMargin: '0px 0px -80px 0px' }
      );
      observer.observe(this.addBtn);
    }

    initPerso() {
      this.persoWrap = this.querySelector('[data-perso]');
      if (!this.persoWrap) return;
      this.persoInputs = this.persoWrap.querySelectorAll('[data-prop]');

      this.persoInputs.forEach((input) => {
        input.addEventListener('input', () => {
          if (input.hasAttribute('data-upper')) input.value = input.value.toUpperCase();
          if (input.hasAttribute('data-num')) input.value = input.value.replace(/[^0-9]/g, '');
          if (input.value.trim() !== '') {
            input.setAttribute('name', `items[0][properties][${input.dataset.prop}]`);
          } else {
            input.removeAttribute('name');
          }
        });
      });

      this.syncPerso();
    }

    // Some junto com o tile: o campo só entra no carrinho quando "sim" está
    // marcado e tem texto — senão o properties[] nem existe no submit.
    syncPerso() {
      if (!this.persoWrap) return;
      const checked = this.persoWrap.querySelector('[data-perso-choice]:checked');
      const on = checked?.value === 'on';
      this.persoWrap.classList.toggle('is-on', on);

      this.persoInputs.forEach((input) => {
        input.disabled = !on;
        if (!on) {
          input.value = '';
          input.removeAttribute('name');
        }
      });
    }

    initPatches() {
      this.patchWrap = this.querySelector('[data-patches]');
      if (!this.patchWrap) return;
      this.patchIdField = this.querySelector('[data-patch-id]');
      this.patchPropFields = this.querySelectorAll('[data-patch-prop], [data-patch-for]');
      this.patchLabel = this.patchWrap.querySelector('[data-patch-selected]');
      this.patchButtons = this.patchWrap.querySelectorAll('[data-patch]');

      this.patchButtons.forEach((btn) => {
        btn.addEventListener('click', () => this.togglePatch(btn));
      });
    }

    // Só um patch por vez: clicar no que já está escolhido tira. O input
    // escondido some do submit quando desabilitado — o mesmo truque da
    // personalização, sem precisar zerar o value manualmente em todo lugar.
    togglePatch(btn) {
      const wasSelected = btn.classList.contains('is-selected');
      this.patchButtons.forEach((b) => b.classList.remove('is-selected'));

      if (wasSelected) {
        if (this.patchLabel) this.patchLabel.textContent = '';
        if (this.patchIdField) this.patchIdField.disabled = true;
        this.patchPropFields.forEach((f) => { f.disabled = true; });
        return;
      }

      btn.classList.add('is-selected');
      if (this.patchLabel) this.patchLabel.textContent = btn.dataset.patchName;
      if (this.patchIdField) {
        this.patchIdField.value = btn.dataset.variantId;
        this.patchIdField.disabled = false;
      }
      this.patchPropFields.forEach((f) => {
        if (f.hasAttribute('data-patch-prop')) f.value = btn.dataset.patchShort || btn.dataset.patchName;
        f.disabled = false;
      });
    }
  }

  // Trilho com snap nativo, igual aos carrosséis da home: o dedo arrasta e
  // o navegador cuida da transição. O JS só rola pro slide certo (timer ou
  // clique no ponto) e escuta o scroll pra manter o ponto ativo em dia.
  class OfferRotator extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('[data-stage]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      if (!this.stage || this.slides.length < 2) return;

      this.index = 0;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          this.show(i);
          this.start();
        });
      });

      this.stage.addEventListener('scroll', () => this.onScroll(), { passive: true });

      // Para enquanto a pessoa está lendo/arrastando, e para de vez se ela escolheu um.
      this.addEventListener('pointerenter', () => this.stop());
      this.addEventListener('pointerleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      if (this.reduceMotion) return;
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    show(index) {
      this.index = index;
      const slide = this.slides[index];
      if (slide) {
        this.stage.scrollTo({
          left: slide.offsetLeft - this.stage.offsetLeft,
          behavior: this.reduceMotion ? 'auto' : 'smooth',
        });
      }
      this.setActiveDot(index);
    }

    // O dedo pode largar o arrasto em qualquer posição: espera parar de
    // rolar e só então descobre em qual slide o snap encaixou.
    onScroll() {
      clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => {
        const width = this.stage.clientWidth || 1;
        this.index = Math.round(this.stage.scrollLeft / width);
        this.setActiveDot(this.index);
      }, 120);
    }

    setActiveDot(index) {
      this.dots.forEach((dot, i) => {
        dot.setAttribute('aria-selected', String(i === index));
      });
    }

    start() {
      this.stop();
      const wait = (Number(this.dataset.interval) || 4) * 1000;
      this.timer = setInterval(() => {
        this.show((this.index + 1) % this.slides.length);
      }, wait);
    }

    stop() {
      clearInterval(this.timer);
    }
  }

  if (!customElements.get('offer-rotator')) {
    customElements.define('offer-rotator', OfferRotator);
  }

  if (!customElements.get('product-page')) {
    customElements.define('product-page', ProductPage);
  }

  // Mesma gramática de gaveta do painel de compras/salvos (dialog nativo,
  // showModal, data-state pra animar); só o conteúdo muda.
  class SizeGuide extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-size-guide]');
      this.sheet = this.querySelector('[data-sheet]');
      if (!this.dialog) return;

      document.addEventListener('click', (event) => {
        if (event.target.closest('[data-open="size-guide"]')) this.open();
      });

      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) return this.close();
        if (event.target.closest('[data-close]')) this.close();
      });

      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      });

      this.dialog.querySelectorAll('[data-sgtab]').forEach((tab) => {
        tab.addEventListener('click', () => {
          const key = tab.dataset.sgtab;
          this.dialog.querySelectorAll('[data-sgtab]').forEach((t) => {
            t.classList.toggle('is-active', t === tab);
            t.setAttribute('aria-selected', String(t === tab));
          });
          this.dialog.querySelectorAll('[data-sgpanel]').forEach((panel) => {
            panel.classList.toggle('is-active', panel.dataset.sgpanel === key);
          });
        });
      });

      // abre na aba do tipo do produto (data-default-tab vem do snippet size-guide, pelo título)
      const inicial = this.dataset.defaultTab;
      if (inicial && inicial !== 'fan') this.dialog.querySelector('[data-sgtab="' + inicial + '"]')?.click();
    }

    open() {
      if (!this.dialog || this.dialog.open) return;
      this.dialog.showModal();
      requestAnimationFrame(() => {
        this.dialog.dataset.state = 'open';
      });
    }

    close() {
      if (!this.dialog?.open) return;
      delete this.dialog.dataset.state;

      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        this.dialog.close();
      };
      this.sheet.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, 700);
    }
  }

  if (!customElements.get('size-guide')) {
    customElements.define('size-guide', SizeGuide);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  // Busca a si mesmo pela Section Rendering API assim que entra na página —
  // é a única forma de popular `recommendations` de verdade (ver comentário
  // no topo do arquivo). Sem resultado, o próprio elemento some. As setas
  // são cuidadas aqui mesmo (não em <flp-carousel>): o JS de seção da
  // Shopify só roda em páginas que usam aquela seção de verdade, e a
  // página de produto não usa product-carousel.
  class RelatedProducts extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;
      if (!url) return this.initCarousel();

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const fresh = doc.querySelector('related-products');
          if (fresh && fresh.innerHTML.trim() !== '') {
            this.innerHTML = fresh.innerHTML;
            this.removeAttribute('hidden');
            this.initCarousel();
          } else {
            this.remove();
          }
        })
        .catch(() => {
          this.remove();
        });
    }

    initCarousel() {
      this.track = this.querySelector('[data-track]');
      this.arrows = Array.from(this.querySelectorAll('[data-scroll]'));
      if (!this.track) return;

      this.arrows.forEach((arrow) => {
        arrow.addEventListener('click', () => this.step(arrow.dataset.scroll));
      });

      this.track.addEventListener('scroll', () => this.sync(), { passive: true });
      new ResizeObserver(() => this.sync()).observe(this.track);
      this.sync();
    }

    step(direction) {
      const card = this.track.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const distance = card.getBoundingClientRect().width + gap;
      this.track.scrollBy({ left: direction === 'next' ? distance : -distance, behavior: 'smooth' });
    }

    sync() {
      const max = this.track.scrollWidth - this.track.clientWidth - 1;
      const atStart = this.track.scrollLeft <= 0;
      const atEnd = this.track.scrollLeft >= max;
      this.arrows.forEach((arrow) => {
        arrow.disabled = arrow.dataset.scroll === 'next' ? atEnd : atStart;
      });
    }
  }

  if (!customElements.get('related-products')) {
    customElements.define('related-products', RelatedProducts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-stories"] && !Shopify.designMode) return;
  try {
    
  class VideoStories extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.stage = this.querySelector('[data-stage]');
      this.modal = this.querySelector('[data-modal]');
      this.toastEl = this.querySelector('[data-toast]');
      this.reward = this.querySelector('[data-reward]');
      this.stories = Array.from(this.querySelectorAll('[data-story]'));
      this.arrows = Array.from(this.querySelectorAll('[data-scroll]'));
      if (!this.track) return;

      this.restoreLikes();

      this.arrows.forEach((arrow) => {
        arrow.addEventListener('click', () => this.step(arrow.dataset.scroll));
      });
      this.track.addEventListener('scroll', () => this.syncArrows(), { passive: true });
      this.syncArrows();

      this.addEventListener('click', (event) => this.onClick(event));
      this.modal?.addEventListener('close', () => this.onModalClose());
      this.modal?.addEventListener('cancel', () => this.onModalClose());

      // Só o que está na tela carrega e toca. Fora dela, pausa.
      this.watcher = new IntersectionObserver(
        (entries) => entries.forEach((entry) => this.toggleVideo(entry)),
        { threshold: 0.6 }
      );
      this.stories.forEach((story) => this.watcher.observe(story));
    }

    disconnectedCallback() {
      this.watcher?.disconnect();
    }

    /* ---------- vídeo ---------- */

    toggleVideo(entry) {
      const video = entry.target.querySelector('[data-video]');
      if (!video) return;

      if (!entry.isIntersecting) {
        video.pause();
        return;
      }

      // Primeira vez que aparece: só agora as sources ganham src de verdade.
      if (!video.dataset.ready) {
        video.querySelectorAll('source[data-src]').forEach((source) => {
          source.src = source.dataset.src;
        });
        video.dataset.ready = 'true';
        video.load();
      }

      video.play().catch(() => {
        /* autoplay bloqueado: o poster segura a peça */
      });
    }

    /* ---------- interações ---------- */

    onClick(event) {
      const open = event.target.closest('[data-open]');
      if (open) return this.open(open.closest('[data-story]'));

      if (event.target.closest('[data-close]')) return this.modal.close();

      if (event.target.closest('[data-reward-close]')) return this.reward.close();

      const copy = event.target.closest('[data-copy-reward]');
      if (copy) return this.copyCode(copy);

      const like = event.target.closest('[data-like]');
      if (like) return this.toggleLike(like);

      const share = event.target.closest('[data-share]');
      if (share) return this.share(share);

      const sound = event.target.closest('[data-sound]');
      if (sound) return this.toggleSound(sound);
    }

    open(story) {
      if (!story || !this.modal) return;
      this.modal.appendChild(this.track);
      this.modal.showModal();
      story.scrollIntoView({ block: 'center' });
    }

    onModalClose() {
      // A fita volta pra casa; o vídeo que estava tocando não é recarregado.
      this.stage.appendChild(this.track);
      this.stories.forEach((story) => {
        const video = story.querySelector('[data-video]');
        if (video) video.muted = true;
      });
      this.querySelectorAll('[data-sound]').forEach((btn) => this.setSoundState(btn, false));
    }

    toggleLike(button) {
      const liked = button.getAttribute('aria-pressed') !== 'true';
      button.setAttribute('aria-pressed', String(liked));

      const id = button.closest('[data-story]')?.dataset.id;
      if (!id) return;

      const all = this.readLikes();
      const next = liked ? [...new Set([...all, id])] : all.filter((x) => x !== id);
      try {
        localStorage.setItem('flp:liked-stories', JSON.stringify(next));
      } catch {
        /* navegação privada: a curtida vale só nesta visita */
      }

      if (liked) this.offerReward();
    }

    offerReward() {
      if (!this.reward) return;
      try {
        if (localStorage.getItem('flp:reward-seen')) return;
        localStorage.setItem('flp:reward-seen', '1');
      } catch {
        /* sem storage: aparece uma vez por visita, e está bom */
        if (this.rewardShown) return;
      }
      this.rewardShown = true;
      this.reward.showModal();
    }

    async copyCode(button) {
      const code = button.dataset.code || '';
      try {
        await navigator.clipboard.writeText(code);
        this.toast(this.toastEl.dataset.copiedCode || 'Code copied');
      } catch {
        this.toast(code);
      }
    }

    readLikes() {
      try {
        return JSON.parse(localStorage.getItem('flp:liked-stories') || '[]');
      } catch {
        return [];
      }
    }

    restoreLikes() {
      const liked = this.readLikes();
      this.stories.forEach((story) => {
        if (!liked.includes(story.dataset.id)) return;
        story.querySelector('[data-like]')?.setAttribute('aria-pressed', 'true');
      });
    }

    async share(button) {
      const url = new URL(button.dataset.url || location.pathname, location.origin).href;
      const title = button.dataset.title || document.title;

      if (navigator.share) {
        try {
          await navigator.share({ title, url });
          return;
        } catch {
          return; /* o visitante cancelou */
        }
      }

      try {
        await navigator.clipboard.writeText(url);
        this.toast(this.toastEl.dataset.copied || 'Link copied');
      } catch {
        this.toast(url);
      }
    }

    toggleSound(button) {
      const on = button.getAttribute('aria-pressed') !== 'true';
      this.setSoundState(button, on);

      const video = button.closest('[data-story]')?.querySelector('[data-video]');
      if (!video) return;
      video.muted = !on;
      if (on) video.play().catch(() => {});
    }

    setSoundState(button, on) {
      button.setAttribute('aria-pressed', String(on));
      const off = button.querySelector('[data-when="off"]');
      const onIcon = button.querySelector('[data-when="on"]');
      if (off) off.hidden = on;
      if (onIcon) onIcon.hidden = !on;
    }

    toast(message) {
      if (!this.toastEl) return;
      this.toastEl.textContent = message;
      this.toastEl.hidden = false;
      clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(() => {
        this.toastEl.hidden = true;
      }, 2400);
    }

    /* ---------- setas ---------- */

    step(direction) {
      const card = this.track.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const distance = card.getBoundingClientRect().width + gap;
      this.track.scrollBy({ left: direction === 'next' ? distance : -distance, behavior: 'smooth' });
    }

    syncArrows() {
      const max = this.track.scrollWidth - this.track.clientWidth - 1;
      this.arrows.forEach((arrow) => {
        arrow.disabled =
          arrow.dataset.scroll === 'next' ? this.track.scrollLeft >= max : this.track.scrollLeft <= 0;
      });
    }
  }

  if (!customElements.get('video-stories')) {
    customElements.define('video-stories', VideoStories);
  }

  } catch(e) { console.error(e); }
})();
})();
